module.exports = __webpack_public_path__ + "assets/img/btn-view-d98f3f6b.png";